import styled from 'styled-components';
import { StyledEntityItem } from 'components/Global/EntityItem/styled.js';

/* HORIZONTAL BAR ELEMENTS */

export const HorizontalBarContainer = styled.div`
  width: ${({ pctWidth }) => pctWidth || '100%'};
  height: 2px;
  background-color: #ebebeb;
  border-radius: 100px;
  position: relative;
  display: inline-block;
`;

export const HorizontalBarWrapper = styled.div`
  width: ${({ pctWidth }) => pctWidth || '100%'};
  padding: 0 20px;
  display: inline-block;

  ${HorizontalBarContainer} {
    vertical-align: middle;
  }
`;

export const HorizontalBarFill = styled.div`
  width: ${({ fillPct }) => fillPct || '0%'};
  min-width: 8px;
  height: 100%;
  border-radius: 100px;
  transition: width 1s ease-in-out;
  background-color: ${({ fillPct, theme }) => {
    if (fillPct.slice(0, -1) >= 50) {
      return theme.colors.palette[7];
    }
    return theme.colors.palette[5];
  }};
`;

/* LABELS */
export const LabelName = styled.div`
  width: 100%;
  display: inline-block;
  text-align: left;
  text-transform: capitalize;
`;

export const LabelValue = styled.div`
  display: inline-block;
  text-align: right;
  vertical-align: middle;
`;

export const StackedFillBarLabelContainer = styled.div`
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;

  ${LabelName} {
    width: 70%;
  }

  ${LabelValue} {
    width: 30%;
  }
`;

export const FillBarLabelContainer = styled.div`
  width: ${({ labelWidth }) => labelWidth || '20%'};
  display: inline-block;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  padding-left: 20px;
  text-align: left;
  vertical-align: middle;

  @media (max-width: 1300px) {
    ${LabelName} {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  ${StyledEntityItem} {
    width: unset;
  }
`;

export const StackedFillBarValueContainer = styled.div`
  width: ${({ pctWidth }) => pctWidth || '10%'};
  display: inline-block;
  text-align: right;
`;

export const StackedLabelValue = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  padding-right: 20px;
`;

export const StyledHorizontalFillBar = styled.div`
  margin-bottom: 12px;
`;
